export const environment = {
  production: false,
  backendUrl: 'https://apphubhml.portoseguro.brasil'
  //backendUrl: 'https://ressarcimento-propostas-app-hml-psg-juridico-recupera.apps.ocpnpr.portoseguro.brasil'
};